import { usePathname, useRouter } from 'next/navigation';
import { useContext, useEffect } from 'react';

import { AppContext } from '../../App';
import { KDSPermission, RoutePaths } from '../../libs';

const LANDED_KEY = 'landedOnToday';
const ROOT: string = RoutePaths.componentsCheck;

// True the first time it is asked in a browser session. Where storage is blocked it never lands, so no loop can start.
const firstLanding = (): boolean => {
  try {
    if (globalThis.sessionStorage.getItem(LANDED_KEY) !== null) {
      return false;
    }
    globalThis.sessionStorage.setItem(LANDED_KEY, 'yes');
    return true;
  } catch {
    return false;
  }
};

const LandOnToday = () => {
  const { user } = useContext(AppContext);
  const pathname = usePathname();
  const router = useRouter();
  const isHeadChef = user.permissions?.includes(KDSPermission.HEAD_CHEF) === true;

  useEffect(() => {
    if (isHeadChef && pathname === ROOT && firstLanding()) {
      router.replace(RoutePaths.home);
    }
  }, [isHeadChef, pathname, router]);

  return null;
};

export default LandOnToday;
